const organization = {
    require_membership: "L'utente deve essere un membro dell'organizzazione per procedere.",
};
export default Object.freeze(organization);
